<div class="relative">
  <!-- Prefix Icon -->
  @if (prefix) {
  <ng-container>
    <span class="absolute left-3 top-1/2 transform -translate-y-1/2 cursor-pointer">
      <ng-container *ngTemplateOutlet="prefix"></ng-container>
    </span>
  </ng-container>
  }

  <input type="text" [placeholder]="placeholder | translate" [(ngModel)]="value" (input)="onInput($event)"
    [disabled]="disabled" class="w-full h-12 shadow p-3 text-base text-black rounded-xl outline-none" [ngClass]="{
      'border-red-500': isError,
      'border-gray-300': !isError && !disabled,
      'bg-gray-100': disabled
    }" />

  <!-- Suffix Icon -->
  @if (suffix) {
  <ng-container>
    <span class="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer">
      <ng-container *ngTemplateOutlet="suffix"></ng-container>
    </span>
  </ng-container>
  }

  <!-- Dropdown Suggestions -->
  @if (showDropdown) {
  <ul class="absolute z-10 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1">
    @for (suggestion of suggestions; track suggestion.place_id || suggestion.place_name) {
    <li class="p-2 cursor-pointer hover:bg-gray-100" (click)="selectSuggestion(suggestion)">
      {{ suggestion.place_name }}
    </li>
    }
  </ul>
  }
</div>